import React, { useState } from "react";

import MainLayout from "../layouts/Main";
import OrganizationForm from "../views/forms/Organization";
import EmployerForm from "../views/forms/Employer";

import useGetOrganizations from "../../hooks/organizations/useGetOrganizations";

import { ISelectedData, ITreeItemES } from "../../interfaces/tree";
import { EtyEmployer, EtyOrganization } from "../../interfaces/entities";

const OrganizationsPage = () => {
    const [selected, setSelected] = useState<ISelectedData | null>(null);
    const [expanded, setExpanded] = useState<ITreeItemES[]>([]);

    const { data: organizations } = useGetOrganizations();

    return (
        <MainLayout
            organizationsData={{
                organizations: organizations ?? [],
                selected,
                setSelected,
                expanded,
                setExpanded,
            }}
        >
            <div className="immployer_admin__organizations__page_view">
                {selected?.level === 0 &&
                    <OrganizationForm
                        organizationData={selected.data as EtyOrganization}
                        selected={selected}
                        setSelected={setSelected}
                        expanded={expanded}
                        setExpanded={setExpanded}
                    />
                }
                {selected?.level === 1 &&
                    <EmployerForm
                        employerData={selected.data as EtyEmployer}
                        selected={selected}
                        setSelected={setSelected}
                        expanded={expanded}
                        setExpanded={setExpanded}
                    />
                }
                {!selected &&
                    <div className="immployer_admin__organizations_page__no_selection">
                        <br /><br />
                        <h3 className="dark_color">Manage Organizations</h3>
                        <br />
                        <p className="wt_500">Add/Update the organizations. Manage users and employers of the organization.</p>
                        <p className="wt_500">Select/Add the organization to proceed.</p>
                    </div>
                }
            </div>
        </MainLayout>
    );
};

export default OrganizationsPage;